export default "__VITE_ASSET__DzA9YWY2__"